import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import { Toolbar, ToolbarGroup } from 'material-ui/Toolbar';
import MediaQuery from 'react-responsive';

import AppLogo from '../app_logo/app_logo';
import AppBarNavigation from '../app_bar_navigation/app_bar_navigation';
import AppBarUserProfile from '../../containers/app_bar_user_profile';
import COLORS from '../../theme/colors';

import './app_bar.scss';

export default function AppBar(props) {
  function getToolbar(style) {
    return (
      <Toolbar style={{ backgroundColor: COLORS.blue, ...style }}>
        <ToolbarGroup>
          <AppLogo />
          {
            props.user &&
            <AppBarNavigation
              currentPath={props.currentPath}
            />
          }
        </ToolbarGroup>

        <ToolbarGroup>
          {
            props.user
              ? <AppBarUserProfile />
              : <Link
                to="/login"
                style={{ color: COLORS.white }}
              >
                Sign In
              </Link>
          }
        </ToolbarGroup>
      </Toolbar>
    );
  }

  return (
    <div className="app-bar">
      <MediaQuery minDeviceWidth={480}>
        { getToolbar({ padding: '0 24px' }) }
      </MediaQuery>

      <MediaQuery maxDeviceWidth={479}>
        { getToolbar({ padding: '0 16px' }) }
      </MediaQuery>
    </div>
  );
}

AppBar.propTypes = {
  user: PropTypes.object,
  currentPath: PropTypes.string.isRequired,
};

AppBar.defaultProps = {
  user: null,
};



// WEBPACK FOOTER //
// ./src/components/app_bar/app_bar.jsx